import Vue from 'vue';
import JQuery from 'jquery';
import App from './App.vue';
import router from './router';
import store from './store';
import DateRangePicker from 'vue-mj-daterangepicker';
import Swal from 'sweetalert2';
import './views/Main/Events/Calendar/daterangepicker.css';
import Axios from 'axios';
import 'popper.js';
import 'bootstrap';
import 'vue-loading-overlay/dist/vue-loading.css';

window.$ = window.jQuery = JQuery;
window.Swal = Swal;


let owl_carousel = require('./assets/js/owl.carousel.js');
window.fn = owl_carousel;


Vue.use(DateRangePicker)

Vue.config.productionTip = false;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});


new Vue({
    router,
    store,
    DateRangePicker,
    render: h => h(App),
}).$mount('#app')


Vue.prototype.$http = Axios
Vue.prototype.$toast = Toast
Vue.prototype.$swal = Swal;
const token = localStorage.getItem('token')

if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}